import { GET_POTY_TOURNAMENT_SEASON_LOADING,
    GET_POTY_TOURNAMENT_SEASON_SUCCESS,
    GET_POTY_TOURNAMENT_SEASON_ERROR
 } from "../../../constant/actionTypes";

 const getPotyTournamentSeason = (state = {}, action) => {
    switch (action.type) {
      case GET_POTY_TOURNAMENT_SEASON_LOADING: {
        let obj = {
          loading: true,
        };
        return obj;
      }
      case GET_POTY_TOURNAMENT_SEASON_SUCCESS: {
        let obj = {
          loading: false,
          data: action.response,
        };
        return obj;
      }
      case GET_POTY_TOURNAMENT_SEASON_ERROR: {
        let obj = {
          loading: false,
          status: action.response,
        };
        return obj;
      }
      default:
        return state;
    }
  };

  export default getPotyTournamentSeason;